import React from "react";
import {Button, Space, Tooltip} from "antd";
import {DeleteOutlined, PlusOutlined, UndoOutlined} from "@ant-design/icons";

export function AdminOtpActions({requireOTP, disabled, onAction}) {
  if (typeof requireOTP !== "boolean") return <span>-</span>;

  return requireOTP ? (
    <Space>
      <Tooltip title="OTP 초기화">
        <Button
          danger ghost shape="circle" icon={<UndoOutlined/>}
          aria-label="OTP 초기화" disabled={disabled}
          onClick={() => onAction("otpReset")}
        />
      </Tooltip>
      <Tooltip title="OTP 삭제">
        <Button
          danger type="primary" shape="circle" icon={<DeleteOutlined/>}
          aria-label="OTP 삭제" disabled={disabled}
          onClick={() => onAction("otpDelete")}
        />
      </Tooltip>
    </Space>
  ) : (
    <Tooltip title="OTP 생성">
      <Button
        type="primary" shape="circle" icon={<PlusOutlined/>}
        aria-label="OTP 생성" disabled={disabled}
        onClick={() => onAction("otpCreate")}
      />
    </Tooltip>
  );
}
